import React from "react";

const Header = () => {
    return (
        <div className="header">
            <span>{localStorage.getItem("company")}</span>
        </div>
    )
}

export default Header;